import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useLocation, useHistory } from "react-router-dom";
import Services from './services/services';
import { Button } from "@material-ui/core";
import { notificationAlertErrorApi } from "../../../../method/notificationAlertErrorApi/notificationAlertErrorApi";
import { useDispatch } from "react-redux";
import { actionTypes as actionTypesNotif } from './../../../../../redux/notificationAlert/index';
import { register_trading_system } from "../../../../../redux/services/registerTradingSystem/registerTradingSystem";

let useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        minHeight: '100vh',
    },
    gridLogo: {
        width: 209,
        marginTop: 72,
        margin: 'auto',
        '& > img': {
            width: '100%',
        }
    },
    grid: {
        width: '90%',
        maxWidth: 1198,
        padding: 32,
        borderRadius: 32,
        boxShadow: "0px 2px 15px 0px #0000000D",
        margin: 'auto',
        marginTop: 44,
        backgroundColor: '#ffffff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '75vh',
        textAlign: 'center',
        position: 'relative',
    },
    title: {
        color: '#323232',
        fontWeight: 'bold',
        marginTop: 28,
    },
    customButton: {
        backgroundColor: '#0B1742 !important',
        color: '#fff',
        margin: 'auto !important',
        minWidth: "160px !important",
        minHeight: "40px !important",
    },
    gridTitle: {
        position: 'absolute',
        top: 64,
        left: '5%',
    },
    gridBtns: {
        width: '90%',
        maxWidth: 1198,
        margin: 'auto',
        marginTop: 20,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    customButton: {
        backgroundColor: '#0B1742 !important',
        color: '#fff',
        minWidth: "160px !important",
        minHeight: "40px !important",
    },
}))



const Index = () => {

    let classes = useStyles();
    let dispatch = useDispatch();
    const location = useLocation();
    const navigate = useHistory();

    const { national_id, token } = location.state?.state || location.state || {};


    const [tradingSystemId, setTradingSystemId] = useState(null);
    const [loading, setLoading] = useState(false);

    const apiSubmit = () => {

        if (loading) return

        if (!tradingSystemId) {
            dispatch(({
                type: actionTypesNotif?.warning,
                textAlert: 'لطفا سامانه معاملاتی خود را انتخاب نمایید'
            }))
            return
        }

        let payload = {
            data: {
                NationalCode: national_id,
                tradingSystemId: tradingSystemId
            },
            headers: {
                token: token
            }
        }
        register_trading_system(payload)
            .then((res) => {
                if (res?.status === 200) {
                    navigate.push('/register/changeOms/success', { state: { ...location.state, token: res?.data?.data } });
                }
            })
            .catch((error) => {
                notificationAlertErrorApi(error, dispatch)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <div className={classes['root']}>

            <div className={classes['gridLogo']}>
                <img src="/assets/images/register/logoPouyan.png" alt="" />
            </div>
            <div className={classes['grid']}>
                <div className={classes['gridTitle']}>
                    <p>
                        انتخاب پنل معاملاتی
                    </p>
                </div>
                <div>
                    <Services
                        tradingSystemId={tradingSystemId}
                        setTradingSystemId={setTradingSystemId}
                    />
                </div>
            </div>
            <div>
                <div className={classes['gridBtns']}>
                    <Button
                        className={classes.customButton}
                        variant="contained"
                        style={{ color: 'white' }}
                        onClick={() => apiSubmit()}
                    >
                        ذخیره
                    </Button>
                </div>
            </div>
        </div>

    )
}

export default Index                          